import { HttpLink } from '@apollo/client'
import useConfig from 'src/config/hooks/useConfig'
import { useLayoutEffect } from 'react'
import swarmXClient from '../clients/swarmx-client'
import swarmClient from '../clients/swarm-client'
import sx1155Client from '../clients/sx1155-client'

const useUpdateApolloOnChain = () => {
  const config = useConfig()

  useLayoutEffect(() => {
    const updateMainClientLink = () => {
      const newLink = new HttpLink({ uri: config.subgraphUrls.main, headers: {
        Authorization: 'Bearer 2e2730968289f9eb3287cd3f1991a957'
      } })
      swarmXClient.setLink(newLink)
    }

    const updateSwarmClientLink = () => {
      const newLink = new HttpLink({ uri: config.subgraphUrls.swarm })
      swarmClient.setLink(newLink)
    }

    const updateSX1155ClientLink = () => {
      const newLink = new HttpLink({ uri: config.subgraphUrls.sx1155 })
      sx1155Client.setLink(newLink)
    }

    updateSwarmClientLink()
    updateMainClientLink()
    updateSX1155ClientLink()
  }, [
    config.subgraphUrls.main,
    config.subgraphUrls.swarm,
    config.subgraphUrls.sx1155,
  ])
}

export default useUpdateApolloOnChain
